import Mutations from '../../odata/mutations';

export default { ...new Mutations('venueType'), ...new Mutations('venueTypes') };
